export default "__VITE_ASSET__ac09521f__"